import styled from 'styled-components';
import { container, fontSize, spacing } from '../../../theme';

export const StyledOfferSection = styled.div`
  margin: auto;
`;

export const StyledOfferInfo = styled.div`
  margin: auto;
  max-width: ${container('md')};
  text-align: center;
  font-size: ${fontSize('lg')};
  line-height: 1.6;

  ul,
  ol,
  p {
    &:not(::first-child) {
      margin-bottom: 0;
      margin-top: ${spacing('xl')};
    }
  }
`;
